import { styled } from '@mui/material/styles'
import { Button } from 'src/components'

export const ConversationCreateMessageStyles = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  background: '#F7F7FA',
  borderRadius: 4,
  maxHeight: '150px',
  height: '150px',
  alignSelf: 'flex-end',
  marginBottom: '16px',
})

export const SendButtonWrapper = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.info.main, //Theme.LOADING_BLUE
  alignSelf: 'flex-end',
  justifyItems: 'center',

  '& .MuiTypography-root': {
    fontSize: '10px',
    marginRight: '.6rem',
    letterSpacing: '0.15px',
    color: theme.palette.error.main,
  },
}))

export const InputContainerStylesDiv = styled('div')({
  flex: 1,
  padding: '2px  9px',
  overflow: 'scroll',
})

export const BtnToolTipWrapper = styled('span')({
  width: 'fit-content',
  display: 'block',
  marginLeft: 'auto',
})
